"use client"

import styled from "@emotion/styled"
import { Skeleton } from "@mui/material"
import Container from "ui/Container"

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 40px;
  padding-top: 40px;
  padding-bottom: 40px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
    padding-top: 48px;
    padding-bottom: 48px;
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
    padding-bottom: 64px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
`

export default function TrafficIndividualSkeleton() {
  return (
    <>
      <Container paddingMobile={true}>
        <StyledContainer>
          {/* TraffixBox skeleton */}
          <Skeleton variant="rectangular" width="100%" height={200} />

          <TextContainer>
            {/* Generate 3 text boxes with skeleton content */}
            {[1, 2, 3].map((i) => (
              <TextBox key={i}>
                <Skeleton variant="text" width="70%" height={24} />
                <Skeleton variant="text" width="100%" height={20} />
                <Skeleton variant="text" width="90%" height={20} />
                <Skeleton variant="text" width="80%" height={20} />
              </TextBox>
            ))}
          </TextContainer>
        </StyledContainer>
      </Container>
    </>
  )
}
